export default "__VITE_ASSET__DuxPPEmn__"